export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Criar imagem usando IA',
        requestFailed: 'Pedido falhou',
        describeYourImage: 'Descreva a sua imagem',
        numberOfVariations: 'Número de variações',
        chooseStyle: 'Escolha o estilo da sua imagem',
        descriptionPlaceholder: '(eg) Um campo de flores de mostarda num dia de verão com árvores de carvalho',
        clear: 'Claro',
        generate: 'Gerar',
        seeAll: 'Ver tudo',
        tryAnExample: 'Tente um exemplo',
        tryAnother: 'Tente outro',
    },
};
